export default __webpack_public_path__ + "static/media/downward-chevron.37a83990.svg";